import React, { useState, useRef, useImperativeHandle, forwardRef } from 'react';

const LEDIndicator = forwardRef(({ size = 'medium', color = 'green' }, ref) => {
  const [isFlashing, setIsFlashing] = useState(false);
  const flashTimeoutRef = useRef(null);

  const triggerFlash = () => {
    if (flashTimeoutRef.current) {
      clearTimeout(flashTimeoutRef.current);
    }
    setIsFlashing(true);
    flashTimeoutRef.current = setTimeout(() => {
      setIsFlashing(false);
    }, 80);
  };

  useImperativeHandle(ref, () => ({
    flash: triggerFlash,
    isFlashing
  }));

  const sizeConfig = {
    small: {
      ledSize: 12
    },
    medium: {
      ledSize: 20
    },
    large: {
      ledSize: 28
    }
  };

  const colorConfig = {
    green: {
      activeColor: '#00ff88',
      inactiveColor: '#00cc66',
      borderColor: '#888888'
    },
    red: {
      activeColor: '#ff4444',
      inactiveColor: '#aa2222',
      borderColor: '#888888'
    },
    orange: {
      activeColor: '#ff8844',
      inactiveColor: '#aa4422',
      borderColor: '#888888'
    },
    grey: {
  activeColor: '#aaaaaa',
  inactiveColor: '#666666',
  borderColor: '#555555'
}
  };

  const sizeConf = sizeConfig[size] || sizeConfig.medium;
  const colorConf = colorConfig[color] || colorConfig.green;

  const ledStyle = {
    width: sizeConf.ledSize,
    height: sizeConf.ledSize,
    borderRadius: '50%',
    backgroundColor: isFlashing
      ? colorConf.activeColor
      : colorConf.inactiveColor,
    border: `2px solid ${isFlashing ? colorConf.activeColor : colorConf.borderColor}`,
    boxSizing: 'border-box',
    opacity: isFlashing ? 1 : 0.8,
    transform: isFlashing ? 'scale(1.7)' : 'scale(1)',
    transition: isFlashing ? 'all 0.15s cubic-bezier(0.4, 0, 0.2, 1)' : 'none',
    animation: isFlashing ? 'none' : 'pulse 2s ease-in-out infinite',
  };

  return (
    <div style={{ position: 'relative', width: sizeConf.ledSize, height: sizeConf.ledSize }}>
      <style>{`
        @keyframes pulse {
          0%, 100% { opacity: 0.3; }
          50% { opacity: 1; }
        }
      `}</style>
      <div style={ledStyle} />
    </div>
  );
});

export default LEDIndicator;